module.exports = __webpack_public_path__ + "static/media/CompletionYear.a274a98a.svg";